import styled from 'styled-components';

export const IconWrapper = styled.span`
  font-size: 24px;
  margin: -13px 0 0;
  position: absolute;
  left: 15px;
  top: 50%;
  opacity: 0.6;
`;

export const IconWrapperRight = styled(IconWrapper)`
  left: auto;
  right: 15px;
`

export const StyledButton = styled.button`
  background: ${props => props.theme.colors.primary};
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  color: #fff;
  font-weight: 600;
  height: 60px;
  padding: 0 25px 0 40px;
  position: relative;
  text-transform: lowercase;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${props => props.theme.colors.hover.primary};
  }

  .button-description {
    text-align: left;
  }

  &.button-small {
    height: 40px;
    display: inline-block;
    width: auto;
    font-size: ${props => props.theme.fontSizes.small};
    padding: 0 20px 2px;
  }

  &.button-extra-small {
    height: 32px;
    display: inline-block;
    width: auto;
    font-size: ${props => props.theme.fontSizes.small};
    padding: 0 10px 2px;
  }

  &.button-default {
    background: #fff;
    color: ${props => props.theme.colors.text};
    border: 1px ${props => props.theme.colors.border} solid;

    &:hover {
      border-color: #bbb;
      color: #111;
    }

    .wrapper {
      opacity: 0.3;
    }
  }

  &.button-inverse {
    background: none;
    color: ${props => props.theme.colors.primary};
    border: 2px ${props => props.theme.colors.primary} solid;

    &:hover {
      background: ${props => props.theme.colors.primary};
      color: #fff;
    }
  }

  &.button-right {
    padding: 0 40px 0 25px;
    text-align: right;

    .button-description {
      text-align: right;
    }
  }

  &.button-full {
    width: 100%;
    padding: 0 30px;
    text-align: center;

    .button-description {
      text-align: center;
    }
  }
`;

export const StyledLinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  line-height: 1;
  margin: 0;
  cursor: pointer;
  color: ${props => props.theme.colors.primary};
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.colors.darkenPrimary};
  }
`

export const StyledDescription = styled.span`
  display: block;
  width: 100%;
  font-size: ${props => props.theme.fontSizes.extraSmall};
  font-weight: normal;
  opacity: 0.6;
  margin-top: 2px;
`
